import { AngleRight, NeedHelp } from "../../../atoms/CustomIcons";
import { useState } from "react";
import DashboardTemplate from "../../../templates/Dashboard";
import Header from "../../../atoms/Header";
import { Button, Card, Col, Row, Tag } from "antd";
import Filters from "../Components/TemplateFilters";
import { useNavigate } from "react-router-dom";

export default function CreateDeal() {
  const [loading] = useState(false);
  const navigate = useNavigate();

  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];

  const templates = [
    {
      title: "Maintenance Standard",
      tags: [
        { label: "Landscape maintenance", className: "green_tag" },
        { label: "Irrigation", className: "purple_tag" },
      ],
      category: "Residential",
      pricingModel: "Fixed price",
      billing: "Monthly",
    },
    {
      title: "Commercial property grounds keeping",
      tags: [
        { label: "Landscape maintenance", className: "green_tag" },
        { label: "Irrigation", className: "purple_tag" },
      ],
      category: "Commercial",
      pricingModel: "Fixed price",
      billing: "Monthly",
    },
    {
      title: "Lawn care 3-step treatment",
      tags: [{ label: "Lawn care", className: "orange_tag" }],
      category: "Commercial",
      pricingModel: "Fixed price",
      billing: "Post-delivery",
    },
    {
      title: "Outdoor living spaces",
      tags: [{ label: "Enhancements", className: "red_tag" }],
      category: "Residential",
      pricingModel: "Fixed price",
      billing: "Upfront payment",
    },
    {
      title: "Construction project",
      tags: [{ label: "Construction", className: "yellow_tag" }],
      category: "Commercial",
      pricingModel: "Fixed price",
      billing: "Per milestone",
    },
    {
      title: "Warm season weekly maintenance service",
      tags: [
        { label: "Landscape maintenance", className: "green_tag" },
        { label: "Irrigation", className: "purple_tag" },
      ],
      category: "Residential",
      pricingModel: "Fixed price",
      billing: "Monthly",
    },
  ];

  const [filters, setFilters] = useState<{
    type: undefined | string;
    status: undefined | string[];
    state: undefined;
    city: undefined;
    last_user_activity: string[] | undefined;
    onboarding_complete_date: string[] | undefined;
    search_text: undefined | string;
  }>({
    type: undefined,
    status: undefined,
    state: undefined,
    city: undefined,
    last_user_activity: undefined,
    onboarding_complete_date: undefined,
    search_text: undefined,
  });

  return (
    <DashboardTemplate loading={loading}>
      <div className="headerWithButton estimateHeaderCustom">
        <Header
          breadcrumb={[
            { label: "Potential deals", href: `/potential-deals/${companyId}` },
            { label: "Create deal" },
          ]}
          title="Create deal"
          description="Select template for fast proposal creation or create from scratch."
          btnText1="Need help?"
          btnIcon1={<NeedHelp />}
        />

        <div className="createNewButton">
          <Button onClick={() => navigate(`/create-new-deal/${companyId}`)}>
            <Card>
              <img src="/images/estimate/scratch_icon.svg" alt="" />
              <div className="create_text">
                <span className="create_title">Create from scratch</span>
                <span className="create_subtitle">
                  For not regular, custom proposals.
                </span>
                <AngleRight className="angle_right_1" />
              </div>
            </Card>
          </Button>
        </div>
      </div>

      <div className="create_deal_page">
        <Col span={24} className="templates_area">
          <div className="top_bar">
            <div className="new_filters">
              <Filters
                setFilters={setFilters}
                filters={filters}
                archived={false}
                isArchived={() => false}
              />
            </div>
          </div>
          <div className="templates">
            <Row gutter={[8, 8]}>
              {templates.map((template, index) => (
                <Col span={8} key={index}>
                  <Card
                    className="temp_card"
                    onClick={() =>
                      navigate(`/create-new-deal/${companyId}`, {
                        state: { templateTitle: template.title },
                      })
                    }
                  >
                    <h3>{template.title}</h3>
                    <div className="related_tags">
                      {template.tags.length <= 2 ? (
                        template.tags.map((tag, idx) => (
                          <Tag key={idx} className={tag.className}>
                            {tag.label}
                          </Tag>
                        ))
                      ) : (
                        <>
                          {template.tags.slice(0, 2).map((tag, idx) => (
                            <Tag key={idx} className={tag.className}>
                              {tag.label}
                            </Tag>
                          ))}
                          <Tag className="purple_tag">
                            +{template.tags.length - 2}
                          </Tag>
                        </>
                      )}
                    </div>
                    <div className="template_description">
                      <div className="item">
                        <div className="label_text"> Property category: </div>
                        <div className="value_text">
                          <Tag>{template.category}</Tag>
                        </div>
                      </div>
                      <div className="item">
                        <div className="label_text"> Pricing model: </div>
                        <div className="value_text">
                          {template.pricingModel}
                        </div>
                      </div>
                      <div className="item">
                        <div className="label_text"> Billing: </div>
                        <div className="value_text"> {template.billing} </div>
                      </div>
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        </Col>
      </div>
    </DashboardTemplate>
  );
}
